import { RoleProtected } from '../Components/RoleProtected';
import FirmwareManagerView from '../Components/FirmwareManagerPageComp/Views/FirmwareManagerView'
export default function FirmwareManagerPage() {
  return (
    <RoleProtected allowedRoles={["user", "Admin"]} showPageAction="firmware_manager_view">
      <FirmwareManagerView />
    </RoleProtected>
  );
}